import { Upload } from "./generated/root.graphql"

export const toUpload = (file: File): Upload => file as any
